import React from "react";
import style from "./PerUnitSaasOptions.module.css";
import { FormCheck, Table } from "react-bootstrap";
import AddressSelect from "../AddressSelect";
import {
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsTheSameAddress,
} from "../../redux/actions";
import { connect } from "react-redux";

function PerUnitSaasOptions({
  item,
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsTheSameAddress,
}) {
  const hasHardware = item => {
    return item.options.flatMap(
      sel => sel.selections.filter(opt => opt.isHardware)
    ).length > 0;
  }
  return (hasHardware(item) &&
    <div className={style.root}>
      <Table variant="sm" className={style.table}>
        <thead>
          <tr>
            <th colSpan={2}>
              <FormCheck
                type="checkbox"
                onChange={e =>
                  setQuoteItemIsTheSameAddress(item, e.target.checked)
                }
                checked={item.isTheSameAddress}
                label="Same Delivery and Installation Address"
                id={`isTheSameAddress-${item.key}`}
              />
            </th>
          </tr>
          <tr>
            <th>Delivery Address</th>
            <th>Installation Address</th>
          </tr>
        </thead>
        <tbody>
          {Array(item.qty)
            .fill(null)
            .map((_, index) => (
              <tr key={index + 1}>
                <td>
                  <AddressSelect
                    isVisible={!item.isTheSameAddress || index === 0}
                    addressId={item.deliveryAddressId[index]}
                    onAddressIdChange={addressId =>
                      setQuoteItemDeliveryAddress(item, index, addressId)
                    }
                  />
                </td>
                <td>
                  <AddressSelect
                    isVisible={!item.isTheSameAddress}
                    addressId={item.installationAddressId[index]}
                    onAddressIdChange={addressId =>
                      setQuoteItemInstallationAddress(item, index, addressId)
                    }
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>
    </div>
  );
}

export default connect(null, {
  setQuoteItemDeliveryAddress,
  setQuoteItemInstallationAddress,
  setQuoteItemIsTheSameAddress,
})(PerUnitSaasOptions);
